import { useCallback, useMemo, useState } from 'react';

import TabsMenuContext, { type ActionSlot, type TabsMenuContextType } from './TabsMenu.context';

type Props = React.PropsWithChildren;

const TabsMenuContextProvider: React.FC<Props> = (props) => {
  const [actionSlotEl, setActionSlotEl] = useState<ActionSlot>(null);

  const registerActionSlot = useCallback((el: ActionSlot) => setActionSlotEl(el), []);

  const value: TabsMenuContextType = useMemo(
    () => ({
      actionsSlot: actionSlotEl,
      registerActionSlot,
    }),
    [actionSlotEl, registerActionSlot],
  );

  return <TabsMenuContext.Provider {...props} value={value} />;
};

export default TabsMenuContextProvider;
